import { useStoredUser } from "@shared/useStoredUser";
import type { MenuProps } from "antd";
import { Avatar, Button, Flex, Layout, Menu, Tooltip, theme } from "antd";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import logo from "../assets/logo-metrica.svg";
import { findCurrentSection, getNavSections, getSiderItems } from "./navigationConfig";

const COLLAPSED_WIDTH = 64;
const FULL_WIDTH = 200;
const TOP_BAR_HEIGHT = 48;
const COLLAPSED = true;

export function SiderMenu() {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const location = useLocation();
  const storedUser = useStoredUser();

  const sections = useMemo(() => getNavSections(storedUser), [storedUser]);
  const siderItems = useMemo(() => getSiderItems(sections), [sections]);

  const selectedKeys = useMemo(() => {
    const section = findCurrentSection(location.pathname, sections);
    return section ? [section.key] : [];
  }, [location.pathname, sections]);

  const handleClick: MenuProps["onClick"] = ({ key }) => {
    if (typeof key !== "string") {
      return;
    }
    const section = sections.find((s) => s.key === key);
    if (!section) return;
    if (section.externalUrl) {
      window.open(section.externalUrl, "_blank", "noopener,noreferrer");
      return;
    }
    navigate(section.defaultPath);
  };

  return (
    <Layout.Sider
      width={FULL_WIDTH}
      collapsedWidth={COLLAPSED_WIDTH}
      collapsed={COLLAPSED}
      collapsible={false}
      style={{
        borderRight: `1px solid ${token.colorBorder}`,
        background: token.colorBgContainer,
        overflow: "auto",
      }}
    >
      <Flex vertical style={{ height: "100%" }} role="menu" aria-label="Навигация">
        <Flex
          align="center"
          justify="center"
          style={{
            height: TOP_BAR_HEIGHT,
            borderBottom: `1px solid ${token.colorBorder}`,
          }}
        >
          <Tooltip title="Metrica.pro / energo" placement="right">
            <Button
              type="text"
              aria-label="Metrica.pro / energo"
              icon={<Avatar shape="square" size={32} src={logo} />}
              onClick={() => navigate("/dashboard")}
            />
          </Tooltip>
        </Flex>

        <Menu
          mode="inline"
          inlineCollapsed={COLLAPSED}
          items={siderItems}
          selectedKeys={selectedKeys}
          onClick={handleClick}
          style={{ borderInlineEnd: "none", flex: 1, minHeight: 0 }}
        />
      </Flex>
    </Layout.Sider>
  );
}
